import { Typography, Stack, Box, Divider, useTheme } from '@mui/material'
import { convertMinutesToHoursAndMinutes } from '@shared/common'
import { i18WithDefault as t } from '@shared/locales'
import { PaymentSettingAdminDto } from 'service-api/src/types'

export interface FeeStructureProps {
  title: string
  fees: PaymentSettingAdminDto[]
  type: 'earlyArrival' | 'lateDeparture'
}

const generateFeeStructureText = (fee: PaymentSettingAdminDto, type: FeeStructureProps['type'], isLastIdx: boolean) => {
  const orMoreText = isLastIdx ? t('feeStructure.orMore') : ''
  const earlyOrLate = type === 'earlyArrival' ? t('feeStructure.early') : t('feeStructure.late')
  const minutes =
    type === 'earlyArrival' ? convertMinutesToHoursAndMinutes(fee.before!) : convertMinutesToHoursAndMinutes(fee.after!)

  return (
    <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-between">
      <Typography variant="body2">
        {minutes} {orMoreText} {earlyOrLate}
      </Typography>
      <Typography variant="body2">${fee.value}</Typography>
    </Box>
  )
}

export const FeeStructure = ({ title, fees, type }: FeeStructureProps) => {
  const theme = useTheme()

  if (fees.length < 1) {
    return
  }

  return (
    <Stack sx={{ backgroundColor: theme.palette.background.grey, p: 1, borderRadius: 1 }}>
      <Stack flexDirection="row" alignItems="center" px={1}>
        <Typography variant="body2bold">{title}:</Typography>
      </Stack>
      <Divider sx={{ m: 1 }} />
      <Stack>
        {fees
          .sort((feeA, feeB) => (type === 'earlyArrival' ? feeA.before! - feeB.before! : feeA.after! - feeB.after!))
          .map((fee, feeIdx: number) => (
            <Stack key={feeIdx} px={1}>
              {generateFeeStructureText(fee, type, feeIdx === fees.length - 1)}
              {feeIdx !== fees.length - 1 && <Divider sx={{ my: 1 }} />}
            </Stack>
          ))}
      </Stack>
    </Stack>
  )
}
